import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Subscription } from 'rxjs/Subscription';
import { map } from 'rxjs/operators/map';
import uuid from 'uuid/v4';
import { authToOwner } from '@atlaskit/media-core';
import { downloadUrl } from '@atlaskit/media-common/downloadUrl';
import { MediaStore as MediaApi } from '../media-store';
import { isErrorFileState, isFinalFileState, isProcessingFileState, mapMediaFileToFileState, mapMediaItemToFileState } from '../../models/file-state';
import { isNotFoundMediaItemDetails } from '../../models/media';
import { FileFetcherError } from './error';
import { uploadFile } from '../../uploader';
import { getFileStreamsCache } from '../../file-streams-cache';
import { globalMediaEventEmitter } from '../../globalMediaEventEmitter';
import { RECENTS_COLLECTION } from '../../constants';
import isValidId from 'uuid-validate';
import { createFileDataloader } from '../../utils/createFileDataLoader';
import { getMediaTypeFromUploadableFile } from '../../utils/getMediaTypeFromUploadableFile';
import { overrideMediaTypeIfUnknown } from '../../utils/overrideMediaTypeIfUnknown';
import { convertBase64ToBlob } from '../../utils/convertBase64ToBlob';
import { toPromise, fromObservable } from '../../utils/mediaSubscribable';
import { getDimensionsFromBlob } from '../../utils/getDimensionsFromBlob';
import { createMediaSubject } from '../../utils/createMediaSubject';
import { getMediaTypeFromMimeType } from '@atlaskit/media-common/mediaTypeUtils';
import { shouldFetchRemoteFileStates } from '../../utils/shouldFetchRemoteFileStates';
import { PollingFunction } from '../../utils/polling';
import { isEmptyFile } from '../../utils/detectEmptyFile';
import { mediaStore } from '@atlaskit/media-state';
import { createCopyIntentRegisterationBatcher } from '../../utils/createCopyIntentRegisterationBatcher';
import { defaultShouldRetryError } from '../../utils/request/helpers';
import { isCommonMediaClientError, CommonMediaClientError, fromCommonMediaClientError } from '../../models/errors';
export { isFileFetcherError, FileFetcherError } from './error';
var isCopySourceFileWithToken = function isCopySourceFileWithToken(token) {
  return !!token.authProvider;
};
var isCopyDestinationWithToken = function isCopyDestinationWithToken(token) {
  return !!token.authProvider;
};
export var FileFetcherImpl = /*#__PURE__*/function () {
  function FileFetcherImpl(mediaApi) {
    var _this = this;
    var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mediaStore;
    _classCallCheck(this, FileFetcherImpl);
    _defineProperty(this, "getErrorFileState", function (error, id, occurrenceKey) {
      if (isCommonMediaClientError(error)) {
        return fromCommonMediaClientError(id, occurrenceKey, error);
      }
      // ________________________________________________
      // Legacy serializers
      // We need to revisit all the incoming error types and ensure all the "reason" values are known
      // We need to change the input error: any for a known type.
      if (typeof error === 'string') {
        var err = new CommonMediaClientError(error);
        return fromCommonMediaClientError(id, occurrenceKey, err);
      } else {
        var _err2 = new CommonMediaClientError((error === null || error === void 0 ? void 0 : error.reason) || 'unknown', error === null || error === void 0 ? void 0 : error.metadata, error === null || error === void 0 ? void 0 : error.innerError);
        return fromCommonMediaClientError(id, occurrenceKey, _err2);
      }
    });
    _defineProperty(this, "setFileState", function (id, fileState) {
      _this.store.setState(function (state) {
        state.files[id] = fileState;
      });
    });
    // TODO: ----- ADD TICKET TO PASS TRACE ID to this.dataloader.load
    _defineProperty(this, "createDownloadFileStream", function (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh) {
      var subject = createMediaSubject();
      var poll = new PollingFunction();

      // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
      poll.onError = function (error) {
        return subject.error(error);
      };
      poll.execute( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response, fileState;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (forceRefresh) {
                _this.dataloader.clear({
                  id: id,
                  collectionName: collectionName,
                  includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
              }
              _context.next = 3;
              return _this.dataloader.load({
                id: id,
                collectionName: collectionName,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
              });
            case 3:
              response = _context.sent;
              if (!isNotFoundMediaItemDetails(response)) {
                _context.next = 6;
                break;
              }
              throw new FileFetcherError('emptyItems', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey,
                traceContext: response.metadataTraceContext
              });
            case 6:
              if (!isEmptyFile(response)) {
                _context.next = 8;
                break;
              }
              throw new FileFetcherError('zeroVersionFile', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey,
                traceContext: response.metadataTraceContext
              });
            case 8:
              fileState = mapMediaItemToFileState(id, response);
              subject.next(fileState);
              _context.t0 = fileState.status;
              _context.next = _context.t0 === 'processing' ? 13 : _context.t0 === 'processed' ? 15 : 17;
              break;
            case 13:
              // the only case for continuing polling, otherwise this function is run once only
              poll.next();
              return _context.abrupt("break", 17);
            case 15:
              subject.complete();
              return _context.abrupt("break", 17);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
      return subject;
    });
    _defineProperty(this, "getUploadingFileStateBase", function (file, upfrontId) {
      // TODO: DO not modify the input parameter 'content' attribute
      if (typeof file.content === 'string') {
        file.content = convertBase64ToBlob(file.content);
      }
      var content = file.content,
        _file$name = file.name,
        name = _file$name === void 0 ? '' : _file$name;
      var id = upfrontId.id,
        occurrenceKey = upfrontId.occurrenceKey;
      var preview;
      // TODO [MSW-796]: get file size for base64
      var size = 0;
      var mimeType = '';
      if (content instanceof Blob) {
        size = content.size;
        mimeType = content.type;
        preview = {
          value: content,
          origin: 'local'
        };
      }
      var mediaType = getMediaTypeFromUploadableFile(file);
      return {
        id: id,
        occurrenceKey: occurrenceKey,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        preview: preview
      };
    });
    _defineProperty(this, "uploadArtifact", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, file, params, collectionName, traceContext) {
        var _yield$_this$mediaApi, data, _yield$_this$mediaApi2, altData, itemDetails;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
            case 2:
              _yield$_this$mediaApi = _context2.sent;
              data = _yield$_this$mediaApi.data;
              _context2.next = 6;
              return _this.mediaApi.getItems([id], collectionName, traceContext);
            case 6:
              _yield$_this$mediaApi2 = _context2.sent;
              altData = _yield$_this$mediaApi2.data;
              itemDetails = altData.items[0].details; // ------------------------------------------------------------
              _this.setFileState(id, mapMediaItemToFileState(id, itemDetails));
              return _context2.abrupt("return", data);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x, _x2, _x3, _x4, _x5) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getOrFetchFileState", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id, collectionName) {
        var fileState;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              fileState = _this.store.getState().files[id];
              if (!(fileState !== null && fileState !== void 0)) {
                _context3.next = 5;
                break;
              }
              _context3.t0 = fileState;
              _context3.next = 8;
              break;
            case 5:
              _context3.next = 7;
              return _this.getCurrentState(id, {
                collectionName: collectionName
              });
            case 7:
              _context3.t0 = _context3.sent;
            case 8:
              return _context3.abrupt("return", _context3.t0);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x6, _x7) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getDurationOfVideo", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, collectionName) {
        var fileState, aritfactUrl, artifactPath, res, arrayBuffer, uint8Array, mvhdBytes, mvhdIndex, i, j, dataView, start, timeScale, duration, videoLength;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this.getOrFetchFileState(id, collectionName);
            case 2:
              fileState = _context4.sent;
              if (!(fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4'])) {
                _context4.next = 5;
                break;
              }
              throw new Error('File is not a video');
            case 5:
              _context4.next = 7;
              return _this.getArtifactURL(fileState.artifacts, 'video.mp4');
            case 7:
              aritfactUrl = _context4.sent;
              artifactPath = new URL(aritfactUrl).pathname;
              _context4.next = 11;
              return _this.mediaApi.request(artifactPath, {
                headers: {
                  Range: 'bytes=0-199'
                }
              });
            case 11:
              res = _context4.sent;
              _context4.next = 14;
              return res.arrayBuffer();
            case 14:
              arrayBuffer = _context4.sent;
              uint8Array = new Uint8Array(arrayBuffer);
              mvhdBytes = new Uint8Array([109, 118, 104, 100]); // "mvhd" in ASCII
              mvhdIndex = -1;
              i = 0;
            case 19:
              if (!(i <= uint8Array.length - mvhdBytes.length)) {
                _context4.next = 34;
                break;
              }
              mvhdIndex = i;
              j = 0;
            case 22:
              if (!(j < mvhdBytes.length)) {
                _context4.next = 29;
                break;
              }
              if (!(uint8Array[i + j] !== mvhdBytes[j])) {
                _context4.next = 26;
                break;
              }
              mvhdIndex = -1;
              return _context4.abrupt("break", 29);
            case 26:
              j++;
              _context4.next = 22;
              break;
            case 29:
              if (!(mvhdIndex !== -1)) {
                _context4.next = 31;
                break;
              }
              return _context4.abrupt("break", 34);
            case 31:
              i++;
              _context4.next = 19;
              break;
            case 34:
              if (!(mvhdIndex === -1)) {
                _context4.next = 36;
                break;
              }
              throw new Error('Unable to find mvhd bytes');
            case 36:
              // Create DataView for reading big-endian integers
              dataView = new DataView(arrayBuffer);
              start = mvhdIndex + 16; // Skip atom header and version/flags
              // Check if we have enough bytes to read timescale and duration
              if (!(start + 8 > arrayBuffer.byteLength)) {
                _context4.next = 40;
                break;
              }
              return _context4.abrupt("return", 0);
            case 40:
              // flase as second parameter indicates big-endian 32-bit integers
              timeScale = dataView.getUint32(start, false);
              duration = dataView.getUint32(start + 4, false);
              if (!(timeScale === 0)) {
                _context4.next = 44;
                break;
              }
              throw new Error('Timescale is invalid');
            case 44:
              // get the video length in seconds
              videoLength = Math.floor(duration / timeScale);
              return _context4.abrupt("return", videoLength);
            case 46:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x8, _x9) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getVideoDurations", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(files) {
        var promises, durations;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              // get all the duration promises
              promises = files.map( /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref6) {
                  var id, collectionName;
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        id = _ref6.id, collectionName = _ref6.collectionName;
                        _context5.prev = 1;
                        _context5.next = 4;
                        return _this.getDurationOfVideo(id, collectionName);
                      case 4:
                        return _context5.abrupt("return", _context5.sent);
                      case 7:
                        _context5.prev = 7;
                        _context5.t0 = _context5["catch"](1);
                        return _context5.abrupt("return", -1);
                      case 10:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5, null, [[1, 7]]);
                }));
                return function (_x11) {
                  return _ref7.apply(this, arguments);
                };
              }());
              _context6.next = 3;
              return Promise.all(promises);
            case 3:
              durations = _context6.sent;
              return _context6.abrupt("return", durations.reduce(function (acc, curr, i) {
                if (curr !== -1) {
                  var _id = files[i].id;
                  acc[_id] = curr;
                }
                return acc;
              }, {}));
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x10) {
        return _ref5.apply(this, arguments);
      };
    }());
    this.mediaApi = mediaApi;
    this.store = store;
    this.dataloader = createFileDataloader(mediaApi);
    this.copyIntentRegisterationBatcher = createCopyIntentRegisterationBatcher(mediaApi);
  }
  return _createClass(FileFetcherImpl, [{
    key: "getFileState",
    value: function getFileState(id) {
      var _this2 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var collectionName = options.collectionName,
        occurrenceKey = options.occurrenceKey,
        includeHashForDuplicateFiles = options.includeHashForDuplicateFiles,
        forceRefresh = options.forceRefresh;
      if (!isValidId(id)) {
        var subject = createMediaSubject();
        var err = new FileFetcherError('invalidFileId', {
          id: id,
          collectionName: collectionName,
          occurrenceKey: occurrenceKey
        });
        var errorFileState = this.getErrorFileState(err, id, occurrenceKey);
        subject.error(err);
        this.setFileState(id, errorFileState);
        return fromObservable(subject);
      }
      if (forceRefresh) {
        getFileStreamsCache().remove(id);
      }
      return fromObservable(getFileStreamsCache().getOrInsert(id, function () {
        var subject = _this2.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh);
        subject.subscribe({
          next: function next(fileState) {
            _this2.setFileState(id, fileState);
          },
          error: function error(err) {
            var errorFileState = _this2.getErrorFileState(err, id, occurrenceKey);
            _this2.setFileState(id, errorFileState);
          }
        });
        return subject;
      }));
    }
  }, {
    key: "getCurrentState",
    value: function getCurrentState(id, options) {
      return toPromise(this.getFileState(id, options));
    }
  }, {
    key: "getArtifactURL",
    value: function getArtifactURL(artifacts, artifactName, collectionName) {
      return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
  }, {
    key: "getFileBinaryURL",
    value: function getFileBinaryURL(id, collectionName, maxAge) {
      return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
  }, {
    key: "touchFiles",
    value: function touchFiles(descriptors, collection, traceContext) {
      return this.mediaApi.touchFiles({
        descriptors: descriptors
      }, {
        collection: collection
      }, traceContext).then(function (_ref8) {
        var data = _ref8.data;
        return data;
      });
    }
  }, {
    key: "generateUploadableFileUpfrontIds",
    value: function generateUploadableFileUpfrontIds(collection, traceContext) {
      var id = uuid();
      var occurrenceKey = uuid();
      var touchFileDescriptor = {
        fileId: id,
        occurrenceKey: occurrenceKey,
        collection: collection
      };
      var deferredUploadId = this.touchFiles([touchFileDescriptor], collection, traceContext).then(function (touchedFiles) {
        return touchedFiles.created[0].uploadId;
      });
      return {
        id: id,
        occurrenceKey: occurrenceKey,
        deferredUploadId: deferredUploadId
      };
    }
  }, {
    key: "uploadExternal",
    value: function () {
      var _uploadExternal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(url, collection, traceContext) {
        var _this3 = this;
        var uploadableFileUpfrontIds, id, occurrenceKey, subject, deferredBlob, preview, name, fileState;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
              id = uploadableFileUpfrontIds.id, occurrenceKey = uploadableFileUpfrontIds.occurrenceKey;
              subject = createMediaSubject();
              deferredBlob = fetch(url).then(function (response) {
                return response.blob();
              }).catch(function () {
                return undefined;
              });
              preview = new Promise( /*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(resolve, reject) {
                  var blob;
                  return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return deferredBlob;
                      case 2:
                        blob = _context7.sent;
                        if (!blob) {
                          reject('Could not fetch the blob');
                        }
                        resolve({
                          value: blob,
                          origin: 'remote'
                        });
                      case 5:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x15, _x16) {
                  return _ref9.apply(this, arguments);
                };
              }());
              name = url.split('/').pop() || ''; // we create a initial fileState with the minimum info that we have at this point
              fileState = {
                status: 'processing',
                name: name,
                size: 0,
                mediaType: 'unknown',
                mimeType: '',
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
              };
              subject.next(fileState);
              // we save it into the cache as soon as possible, in case someone subscribes
              getFileStreamsCache().set(id, subject);
              this.setFileState(id, fileState);
              return _context9.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(resolve, reject) {
                  var blob, type, size, file, mediaType, dimensions;
                  return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        _context8.next = 2;
                        return deferredBlob;
                      case 2:
                        blob = _context8.sent;
                        if (blob) {
                          _context8.next = 5;
                          break;
                        }
                        return _context8.abrupt("return", reject('Could not download remote file'));
                      case 5:
                        type = blob.type, size = blob.size;
                        file = {
                          content: blob,
                          mimeType: type,
                          collection: collection,
                          name: name,
                          size: size
                        };
                        mediaType = getMediaTypeFromMimeType(type); // we emit a richer state after the blob is fetched
                        subject.next({
                          status: 'processing',
                          name: name,
                          size: size,
                          mediaType: mediaType,
                          mimeType: type,
                          id: id,
                          occurrenceKey: occurrenceKey,
                          preview: preview
                        });
                        // we don't want to wait for the file to be upload
                        _this3.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
                        _context8.prev = 10;
                        _context8.next = 13;
                        return getDimensionsFromBlob(mediaType, blob);
                      case 13:
                        dimensions = _context8.sent;
                        _context8.next = 20;
                        break;
                      case 16:
                        _context8.prev = 16;
                        _context8.t0 = _context8["catch"](10);
                        reject(_context8.t0);
                        return _context8.abrupt("return");
                      case 20:
                        resolve({
                          dimensions: dimensions,
                          mimeType: type,
                          uploadableFileUpfrontIds: uploadableFileUpfrontIds
                        });
                      case 21:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8, null, [[10, 16]]);
                }));
                return function (_x17, _x18) {
                  return _ref10.apply(this, arguments);
                };
              }()));
            case 11:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function uploadExternal(_x12, _x13, _x14) {
        return _uploadExternal.apply(this, arguments);
      }
      return uploadExternal;
    }()
  }, {
    key: "upload",
    value: function upload(file, controller, uploadableFileUpfrontIds, traceContext) {
      var _this4 = this;
      var collection = file.collection;
      var upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
      var id = upfrontId.id,
        occurrenceKey = upfrontId.occurrenceKey;
      var stateBase = this.getUploadingFileStateBase(file, upfrontId);
      var subject = createMediaSubject();
      getFileStreamsCache().set(id, subject);
      var onProgress = function onProgress(progress) {
        var fileState = _objectSpread(_objectSpread({
          status: 'uploading'
        }, stateBase), {}, {
          progress: progress
        });
        subject.next(fileState);
        _this4.setFileState(id, fileState);
      };
      var processingSubscription = new Subscription();
      var onUploadFinish = function onUploadFinish(error) {
        if (error) {
          var errorFileState = _this4.getErrorFileState(error, id, occurrenceKey);
          _this4.setFileState(id, errorFileState);
          return subject.error(error);
        }
        processingSubscription = _this4.createDownloadFileStream(id, collection, occurrenceKey).pipe(map(function (remoteFileState) {
          return _objectSpread(_objectSpread(_objectSpread({}, stateBase), remoteFileState), overrideMediaTypeIfUnknown(remoteFileState, stateBase.mediaType));
        })).subscribe({
          next: function next(fileState) {
            subject.next(fileState);
            _this4.setFileState(id, fileState);
          },
          error: function error(err) {
            var errorFileState = _this4.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            _this4.setFileState(id, errorFileState);
          },
          complete: subject.complete
        });
      };
      var _uploadFile = uploadFile(file, this.mediaApi, upfrontId, {
          onUploadFinish: onUploadFinish,
          onProgress: onProgress
        }, traceContext),
        cancel = _uploadFile.cancel;
      controller === null || controller === void 0 || controller.setAbort(function () {
        cancel();
        // TODO: filestate should turn to "Aborted" or something.
        // Consider canceling an upload that is already finished
        processingSubscription.unsubscribe();
      });

      // We should report progress asynchronously, since this is what consumer expects
      // (otherwise in newUploadService file-converting event will be emitted before files-added)
      setTimeout(onProgress, 0, 0);
      return fromObservable(subject);
    }
  }, {
    key: "downloadBinary",
    value: function () {
      var _downloadBinary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(id) {
        var name,
          collectionName,
          traceContext,
          url,
          _args10 = arguments;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              name = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : 'download';
              collectionName = _args10.length > 2 ? _args10[2] : undefined;
              traceContext = _args10.length > 3 ? _args10[3] : undefined;
              _context10.next = 5;
              return this.mediaApi.getFileBinaryURL(id, collectionName);
            case 5:
              url = _context10.sent;
              downloadUrl(url, {
                name: name
              });
              globalMediaEventEmitter.emit('media-viewed', {
                fileId: id,
                isUserCollection: collectionName === RECENTS_COLLECTION,
                viewingLevel: 'download'
              });
              // Test the download after initiated the Browser process to catch any potential errors.
              _context10.next = 10;
              return this.mediaApi.testUrl(url, {
                traceContext: traceContext
              });
            case 10:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function downloadBinary(_x19) {
        return _downloadBinary.apply(this, arguments);
      }
      return downloadBinary;
    }()
  }, {
    key: "registerCopyIntent",
    value: function () {
      var _registerCopyIntent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(id, collectionName) {
        var auth, key, error;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.mediaApi.resolveAuth({
                collectionName: collectionName
              });
            case 2:
              auth = _context11.sent;
              key = {
                id: id,
                collectionName: collectionName,
                resolvedAuth: auth
              };
              _context11.next = 6;
              return this.copyIntentRegisterationBatcher.load(key);
            case 6:
              error = _context11.sent;
              if (!error) {
                _context11.next = 10;
                break;
              }
              // if the error is retryable then it should not be cached
              if (defaultShouldRetryError(error)) {
                this.copyIntentRegisterationBatcher.clear(key);
              }
              throw error;
            case 10:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function registerCopyIntent(_x20, _x21) {
        return _registerCopyIntent.apply(this, arguments);
      }
      return registerCopyIntent;
    }()
  }, {
    key: "copyFileWithToken",
    value: function () {
      var _copyFileWithToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(source, destination, traceContext) {
        var authProvider, sourceCollection, id, destinationAuthProvider, destinationCollectionName, replaceFileId, occurrenceKey, mediaStore, owner, body, params, _yield$mediaStore$cop, data;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              authProvider = source.authProvider, sourceCollection = source.collection, id = source.id;
              destinationAuthProvider = destination.authProvider, destinationCollectionName = destination.collection, replaceFileId = destination.replaceFileId, occurrenceKey = destination.occurrenceKey;
              mediaStore = destination.mediaStore || new MediaApi({
                authProvider: destinationAuthProvider
              });
              _context12.t0 = authToOwner;
              _context12.next = 6;
              return authProvider({
                collectionName: sourceCollection
              });
            case 6:
              _context12.t1 = _context12.sent;
              owner = (0, _context12.t0)(_context12.t1);
              body = {
                sourceFile: {
                  id: id,
                  collection: sourceCollection,
                  owner: owner
                }
              };
              params = {
                collection: destinationCollectionName,
                replaceFileId: replaceFileId,
                occurrenceKey: occurrenceKey
              };
              _context12.next = 12;
              return mediaStore.copyFileWithToken(body, params, traceContext);
            case 12:
              _yield$mediaStore$cop = _context12.sent;
              data = _yield$mediaStore$cop.data;
              return _context12.abrupt("return", data);
            case 15:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      function copyFileWithToken(_x22, _x23, _x24) {
        return _copyFileWithToken.apply(this, arguments);
      }
      return copyFileWithToken;
    }()
  }, {
    key: "copyFileWithIntent",
    value: function () {
      var _copyFileWithIntent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(source, destination, traceContext) {
        var res, data;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.mediaApi.copyFile(source.id, {
                sourceCollection: source.collection,
                collection: destination.collection,
                replaceFileId: destination.replaceFileId
              }, traceContext);
            case 2:
              res = _context13.sent;
              data = res.data;
              return _context13.abrupt("return", data);
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function copyFileWithIntent(_x25, _x26, _x27) {
        return _copyFileWithIntent.apply(this, arguments);
      }
      return copyFileWithIntent;
    }()
  }, {
    key: "copyFile",
    value: function () {
      var _copyFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(source, destination) {
        var _this5 = this;
        var options,
          traceContext,
          id,
          destinationCollectionName,
          replaceFileId,
          occurrenceKey,
          preview,
          mimeType,
          cache,
          processingSubscription,
          copiedFile,
          copiedFileWithMimeType,
          copiedId,
          copiedMimeType,
          mediaType,
          copiedFileState,
          fileCache,
          subject,
          previewOverride,
          fileState,
          _fileState,
          _fileCache,
          replaceFileState,
          key,
          errorFileState,
          _args14 = arguments;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              options = _args14.length > 2 && _args14[2] !== undefined ? _args14[2] : {};
              traceContext = _args14.length > 3 ? _args14[3] : undefined;
              id = source.id;
              destinationCollectionName = destination.collection, replaceFileId = destination.replaceFileId, occurrenceKey = destination.occurrenceKey;
              preview = options.preview, mimeType = options.mimeType;
              cache = getFileStreamsCache();
              _context14.prev = 6;
              if (!(isCopySourceFileWithToken(source) && isCopyDestinationWithToken(destination))) {
                _context14.next = 13;
                break;
              }
              _context14.next = 10;
              return this.copyFileWithToken(source, destination, traceContext);
            case 10:
              copiedFile = _context14.sent;
              _context14.next = 16;
              break;
            case 13:
              _context14.next = 15;
              return this.copyFileWithIntent(source, destination, traceContext);
            case 15:
              copiedFile = _context14.sent;
            case 16:
              // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
              copiedFileWithMimeType = _objectSpread(_objectSpread({}, copiedFile), mimeType ? {
                mimeType: mimeType
              } : undefined);
              copiedId = copiedFileWithMimeType.id, copiedMimeType = copiedFileWithMimeType.mimeType; // backend may return an "unknown" mediaType just after the copy
              // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
              mediaType = copiedMimeType ? getMediaTypeFromMimeType(copiedMimeType) : 'unknown';
              copiedFileState = mapMediaFileToFileState({
                data: copiedFileWithMimeType
              });
              fileCache = cache.get(copiedId);
              subject = fileCache || createMediaSubject(); // if we were passed a "preview", we propagate it into the copiedFileState
              previewOverride = !isErrorFileState(copiedFileState) && !!preview ? {
                preview: preview
              } : {};
              _context14.t0 = !isFinalFileState(copiedFileState) &&
              // mimeType should always be returned by "copyFileWithToken"
              // but in case it's not, we don't want to penalize "copyFile"
              copiedMimeType;
              if (!_context14.t0) {
                _context14.next = 28;
                break;
              }
              _context14.next = 27;
              return shouldFetchRemoteFileStates(mediaType, copiedMimeType, preview);
            case 27:
              _context14.t0 = _context14.sent;
            case 28:
              if (!_context14.t0) {
                _context14.next = 35;
                break;
              }
              fileState = _objectSpread(_objectSpread(_objectSpread({}, copiedFileState), overrideMediaTypeIfUnknown(copiedFileState, mediaType)), previewOverride);
              subject.next(fileState);
              this.setFileState(copiedId, fileState);
              processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                next: function next(remoteFileState) {
                  var fileState = _objectSpread(_objectSpread(_objectSpread({}, remoteFileState), overrideMediaTypeIfUnknown(remoteFileState, mediaType)), !isErrorFileState(remoteFileState) && previewOverride);
                  _this5.setFileState(copiedId, fileState);
                  return subject.next(fileState);
                },
                error: function error(err) {
                  var errorFileState = _this5.getErrorFileState(err, id, occurrenceKey);
                  _this5.setFileState(copiedId, errorFileState);
                  return subject.error(err);
                },
                complete: function complete() {
                  return subject.complete();
                }
              });
              _context14.next = 36;
              break;
            case 35:
              if (!isProcessingFileState(copiedFileState)) {
                _fileState = _objectSpread(_objectSpread({}, copiedFileState), !isErrorFileState(copiedFileState) && previewOverride);
                subject.next(_fileState);
                this.setFileState(copiedId, _fileState);
              }
            case 36:
              if (!cache.has(copiedId)) {
                getFileStreamsCache().set(copiedId, subject);
              }
              return _context14.abrupt("return", copiedFile);
            case 40:
              _context14.prev = 40;
              _context14.t1 = _context14["catch"](6);
              if (processingSubscription) {
                processingSubscription.unsubscribe();
              }
              if (replaceFileId) {
                _fileCache = cache.get(replaceFileId);
                replaceFileState = this.store.getState().files[replaceFileId];
                if (_fileCache) {
                  _fileCache.error(_context14.t1);
                } else {
                  // Create a new subject with the error state for new subscriptions
                  cache.set(id, createMediaSubject(_context14.t1));
                }
                key = replaceFileState ? replaceFileId : id;
                errorFileState = this.getErrorFileState(_context14.t1, id, occurrenceKey);
                this.setFileState(key, errorFileState);
              }
              throw _context14.t1;
            case 45:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this, [[6, 40]]);
      }));
      function copyFile(_x28, _x29) {
        return _copyFile.apply(this, arguments);
      }
      return copyFile;
    }()
  }]);
}();